<template>

	<a-card :bordered="false" class="dashboard-bar-line header-solid">
		<template #title>
			<h6>Alumni Overview</h6>			
			<p>report Engagement and Achievement of Alumni<span class="text-success"></span></p>	
		</template>
		<template #extra>
			<a-badge color="primary" class="badge-dot-primary" text="Engagement" />
			<a-badge color="primary" class="badge-dot-secondary" text="Achievement" />
		</template>
		<chart-line :height="310" :data="lineChartData"></chart-line>
	</a-card>

</template>

<script>

	// Bar chart for "Active Users" card.
	import ChartLine from '../../components/Charts/ChartLine' ;

	export default ({
		components: {
			ChartLine,
		},
		data() {
			return {

				// Data for line chart.
				lineChartData: {
					labels: ["2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021"],
					datasets: [{
						label: "Engagement",
						tension: 0.4,
						borderWidth: 0,
						pointRadius: 0,
						borderColor: "#1890FF",
						borderWidth: 3,
						data: [200, 180, 220, 220, 170, 202, 219, 220, 240],
						maxBarThickness: 6

					},
					{
						label: "Archievement",
						tension: 0.4,
						borderWidth: 0,
						pointRadius: 0,
						borderColor: "#B37FEB",
						borderWidth: 3,
						data: [120, 90, 80, 50, 74, 68, 69, 56, 75],
						maxBarThickness: 6

					}],
				},
			}
		},
	})

</script>